import script from "./tenant-switch-progress.vue?vue&type=script&setup=true&lang=ts"
export * from "./tenant-switch-progress.vue?vue&type=script&setup=true&lang=ts"

import "./tenant-switch-progress.vue?vue&type=style&index=0&id=f088bf8c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f088bf8c"]])

export default __exports__